import { Component } from 'react';

import { Popover } from '@material-ui/core/'
import { type PopoverProps } from '@material-ui/core/Popover'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  paper: {
    boxShadow: '0px 1px 2px rgba(0,0,0,0.1), 0px 2px 5px rgba(0,0,0,0.2)',
  },
}

class MenuListPopoverStyledComponent extends Component<
  PopoverProps & { classes: any }
> {
  render() {
    const { classes, ...otherProps } = this.props

    return <Popover classes={{ paper: classes.paper }} {...otherProps} />
  }
}

export const MenuListPopoverStyled = withStyles(styles)(
  MenuListPopoverStyledComponent
)
